import React from 'react'
import Photo from "../../../../Assests/Products/Hospitalmang/HUman.png"
const ClickManage = () => {
    return (
        <div className="CompareAnalysis-2" data-aos="zoom-in-left" style={{ width: "90%", margin: "auto" }}>
            <div className="CompareAnalysis-Def">
                <h2>
                Clinical Decision Support:
                </h2>
                <p>
                    Oversee staff management, including recruitment, onboarding, and performance evaluations, all within a single, integrated system.
                </p>

            </div>
            <div className="CompareAnalysis-Photo">
                <img src={Photo} alt="" />
            </div>
        </div>
    )
}

export default ClickManage